import classNames from 'classnames/bind';
import styles from './Live.module.scss';
import images from '~/assets/images';

const cx = classNames.bind(styles);

function Live() {
    return (
        <div className={cx('error-page')}>
            <img src={images.error2} aria-hidden alt="Error Image" className={cx('error-image')} />
            <h1> 直播功能开发中 🥹</h1>
            <p>敬请期待</p>
        </div>
    );
}

export default Live;